import { MDBCol, MDBIcon, MDBRow } from 'mdb-react-ui-kit'
import React from 'react'
import ScrollTo from "react-scroll-into-view";
import ImageBlock from './ImageBlock';
import { motion } from "framer-motion";

const SectionSix = ({sectionId, sectionSelector, sectionImage}) => {
  return (
    <MDBRow id={sectionId} className="row d-flex justify-content-center align-items-center">
        <ImageBlock myImage={sectionImage} />
        <MDBCol className="col-sm-12 col-md-6 text-center d-flex flex-column justify-content-center align-items-center align-self-stretch mb-0 white p-5">
            FERMENTUM ET
            <motion.div initial={{ opacity: 0, x:200 }} whileInView={{  opacity: 1, x:0 }}  transition={{ delay: 0.45 }} >
                <h2 className="display-2 my-4 section-font section-font-color"><strong>VEL PRETIUM LECTUS</strong></h2>
            </motion.div>
            <h4>Pellentesque eu tincidunt tortor aliquam nulla cras. Sit amet purus gravida quis turpis. Massa vitae tortor lacinia quis laoreet curabitur gravida arcu ac tortor dignissim.</h4>
            <ScrollTo selector={sectionSelector}>
              <MDBIcon fas icon="arrow-circle-up" size='4x' className="section-icon my-3 section-font-color"/>
            </ScrollTo>
        </MDBCol>
      </MDBRow>
  )
}

export default SectionSix